import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ParentRelationship,
  AppState,
  AppTypes,
  AppFields,
  take
} from "../../../store";
import { MyProfileDashboardService, HelperService } from "../../../services";
import { NotificationsService } from "angular2-notifications";
import { Store } from "@ngrx/store";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { EvaluationsService } from "../../../services/evaluations.service";
import * as lodash from "lodash";
import { AlertService } from "../../../services/alert.service";

@Component({
  selector: "app-evaluation-check",
  templateUrl: "./evaluation-check.component.html",
  styleUrls: ["./evaluation-check.component.css"]
})
export class PlayerEvaluationCheckComponent implements OnInit {
  evaluatorName: any;
  averageScore: any;
  categories: any;
  responses: any;
  responsesCopy: any;

  newEvaluationsCount: number = 0;
  inProgressEvaluationsCount: number = 0;
  completedEvaluationsCount: number = 0;
  overallAverage: number = 0;

  staffID: any;
  clubID: any;
  members: any;
  membersCopy: any;
  filterValue = 0;

  isShowDashboard: boolean = true;
  isShowCompletedColumn: boolean = false;

  public urlLinks = [
    {
      title: "All Evaluations",
      url: null,
    }
  ];

  isSelectCheckBox: boolean = false;
  selectedRecordIndex = [];
  selectedRecordsCounts: number;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _loadingService: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private _service: EvaluationsService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    // this.staffID = this._route.snapshot.params.staffID;
    console.log("HERE => ngOnInit ==> evaluationCheck");
    this.clubID = +localStorage.getItem("clubId");
    this.staffID = +localStorage.getItem("userId");
    this.onShowStaffAssignedPlayers(this.staffID, 0);
  }

  onShowStaffAssignedPlayers(staffID, clubID) {
    console.log("STAFF ID = ", staffID);
    this._loadingService.show();
    this._service.loadEvaluationsByStaffID(staffID, clubID).subscribe(
      (result: any) => {
        // this.showStaffAssignedPlayers = true;
        console.log("DATA = ", result.data);
        this.members = result.data.evaluations;
        this.membersCopy = this.members;
        this.newEvaluationsCount = result.data.newEvaluationsCount;
        this.inProgressEvaluationsCount =
          result.data.inProgressEvaluationsCount;
        this.completedEvaluationsCount = result.data.completedEvaluationsCount;
        this.overallAverage = result.data.overallAverage;
        this._loadingService.hide();
      },
      error => {
        // this.showStaffAssignedPlayers = false;
        this._loadingService.hide();
        this._alertService.error("Players could not be loaded");
      }
    );
  }

  showPlayerEvaluations(playerID, userEvaluationID) {
    console.log("userEvaluationID => ", userEvaluationID);
    this._router.navigate([
      "details/" + playerID + "/player-evaluation-complete/" + userEvaluationID + "/" + this.filterValue
    ]);
  }

  filterView(status) {
    this.members = this.membersCopy;
    this.filterValue = status;

    if (status > 0) {
      if (status == 3) {
        this.isShowCompletedColumn = true;
      } else {
        this.isShowCompletedColumn = false;
      }
      this.members = this.members.filter(n => n.status == status);
      this.isShowDashboard = false;
    } else {
      this.isShowDashboard = true;
    }
  }

  printDataList: any[] = [];
  selectRecord(pid, ueid, event) {
    if (this.selectedRecordsCounts == 0) {
      this.selectedRecordIndex = [];
      this.printDataList = [];
    }

    var obj = {
      playerID: pid,
      userEvaluationID: ueid,
    }

    if (event.target.checked) {
      this.selectedRecordIndex.push(pid);
      this.printDataList.push(obj);
      this.isSelectCheckBox = true
    }
    else {
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(pid), 1);
      this.printDataList.splice(this.printDataList.indexOf(obj.playerID), 1);
    }
    console.log("printDataList: ", this.printDataList);
  }

  onPrint() {
    if (this.selectedMembers.length > 1) {
      this._alertService.warn("You can only print one evaluation at a time.");
    }
    else {
      let printIDs = [];
      this.selectedMembers.forEach(t => {
        printIDs.push({
          userEvaluationID: t.userEvaluationID,
          playerID: t.playerID
        });
      });
      this._loadingService.show();
      this._service.printOutEvaluationSheet(printIDs).subscribe(
        (rs: any) => {
          this._loadingService.hide();
          console.log("rs: = >", rs);
          //this._alertService.success("Print Successfully");
          this.helperService.downloadFileAndDelete(rs[0]);
        },
        (error) => {
          this._loadingService.hide();
          console.log(error.error);
          this._alertService.error(error.error);
        }
      );
    }
  }
  get selectedMembers() {
    return (this.members || []).filter(t => !!t.checked);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/player/evaluation-check/evaluation-check.component.ts